import SEOHead from '../components/SEOHead';
import { Button, Card, Container, Grid, Stack, Body, Muted, H2, H3, H4 } from '../components/ui';

const PLANS = [
  {
    key: 'options_breakdown',
    name: 'Option Analysis',
    price: '₹299/mo',
    description: 'Full option chain data, Black-Scholes breakdown, and all Greeks for any contract.',
  },
  {
    key: 'greeks_calculator',
    name: 'Greeks Calculator',
    price: '₹199/mo',
    description: 'Real-time Delta, Gamma, Theta, Vega, and Rho calculator for any F&O symbol.',
  },
  {
    key: 'margin_calculator',
    name: 'Margin Calculator',
    price: '₹149/mo',
    description: 'Calculate margin requirements for any options strategy before placing a trade.',
  },
  {
    key: 'position_sizer',
    name: 'Position Sizer',
    price: '₹99/mo',
    description: 'Risk-based position sizing for consistent lot management across all symbols.',
  },
  {
    key: 'ad_free',
    name: 'Ad-Free',
    price: '₹99/mo',
    description: 'Remove all advertisements for a clean, distraction-free OptionView experience.',
  },
];

export default function Upgrade() {
  return (
    <>
      <SEOHead
        title="Upgrade"
        description="Unlock premium OptionView features — Greeks Calculator, Margin Calculator, Position Sizer and more."
        canonicalPath="/upgrade"
      />
      <Container className="py-10">
        <div className="text-center mb-10">
          <H2 className="mb-3">Upgrade Your Plan</H2>
          <Body className="max-w-lg mx-auto text-neutral-600 dark:text-neutral-400">
            Unlock advanced tools built for serious Indian options traders.
            Payments coming soon — contact us to join the waitlist.
          </Body>
        </div>

        <Grid cols={3} gap={6}>
          {PLANS.map(({ key, name, price, description }) => (
            <Card key={key} variant="elevated">
              <Card.Body>
                <Stack gap={4}>
                  <H3>{name}</H3>
                  <H4 className="text-primary-600 dark:text-primary-400">{price}</H4>
                  <Body>{description}</Body>
                  <Button variant="primary" disabled className="w-full">
                    Buy Now
                  </Button>
                  <Muted className="text-center text-xs">Payments coming soon</Muted>
                </Stack>
              </Card.Body>
            </Card>
          ))}
        </Grid>
      </Container>
    </>
  );
}
